import React from "react";
import Box from "../box/Box";
import { TbActivityHeartbeat } from "react-icons/tb";
import { COLORS, Typo } from "../../../../../layout/theme";
import {
	BiBox,
	BiBuildings,
	BiDollar,
	BiCoinStack,
	BiTrash,
	BiCheck,
} from "react-icons/bi";
import { MdSafetyDivider } from "react-icons/md";
import {
	BigChartContainer,
	Container,
	Dashboard1Container,
	DoubleChartContainer,
	FilterContainer,
	HeaderContainer,
} from "./styles";
import { Button, DatePicker, Select, Switch } from "antd";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import { CONSTANTS } from "../../../../../../utils/constants";
import CustomAntdTooltip from "../../../../../common/custom-antd-tooltip/CustomAntdTooltip";

export default function Dashboard2({
	dashboard,
	optionsPie,
	timeSalesGraph,
	timeOrderGraph,
	timeUnitsGraph,
	distributors,
	selectDistributor,
	laboratories,
	selectLaboratory,
	handleDateChange,
	deleteFilters,
	isLoading,
	selectedLaboratory,
	laboratorySalesGraph,
	laboratoryUnitsGraph,
	selectedDistributor,
	rangeDate,
	selectDistributorsInfo,
	distributorsInfoSelector,
	optionsPie2,
	laboratoryGraphSelector,
	selectLaboratoryGraph,
	handleApplyFilters,
}) {
	return (
		<Dashboard1Container>
			<FilterContainer>
				<Container
					style={{
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
						width: "140px",
					}}
				>
					<CustomAntdTooltip
						placement="top"
						width="110px"
						tooltipContent={[
							{
								title: `Aplicar filtros`,
							},
						]}
					>
						<Button
							type="primary"
							onClick={handleApplyFilters}
							icon={<BiCheck />}
							style={{
								borderRadius: 20,
								backgroundColor: COLORS.Success,
								borderColor: COLORS.Success,
							}}
						/>
					</CustomAntdTooltip>
					<CustomAntdTooltip
						placement="top"
						width="100px"
						tooltipContent={[
							{
								title: `Borrar filtros`,
							},
						]}
					>
						<Button
							type="danger"
							onClick={deleteFilters}
							icon={<BiTrash />}
							style={{ borderRadius: 20 }}
						/>
					</CustomAntdTooltip>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Fecha (desde/hasta)
					</Typo>
					{/* <DatePicker.RangePicker onChange={(e) => handleDateChange(e)} /> */}
					{rangeDate ? (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							value={rangeDate}
							onChange={(e) => handleDateChange(e)}
						/>
					) : (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							onChange={(e) => handleDateChange(e)}
						/>
					)}
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Droguería
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Droguería"
						optionFilterProp="children"
						value={selectedDistributor}
						// defaultValue={selectedDistributor ?? null}
						onChange={(e, o) => selectDistributor(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={distributors}
						style={{ width: 180 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Laboratorio
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Laboratorio"
						optionFilterProp="children"
						value={selectedLaboratory}
						// defaultValue={selectedLaboratory ?? null}
						onChange={(e, o) => selectLaboratory(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={laboratories}
						style={{ width: 180 }}
					/>
				</Container>
			</FilterContainer>
			<HeaderContainer>
				<Box
					dataPrefix={"$"}
					data={numberWithDotAndCommas(dashboard?.totalYearSales?.toFixed(0))}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeSalesGraph}
					isLoading={isLoading}
					type="headerBox"
					prefix={<BiBuildings />}
					title={
						<Typo texto="light" type="primary">
							Total ventas
						</Typo>
					}
				/>
				<Box
					data={dashboard?.totalYearUnits}
					subData={
						dashboard?.unitsMonthInfo > 0 ? dashboard?.unitsMonthInfo : null
					}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeUnitsGraph}
					isLoading={isLoading}
					type="headerBox"
					prefix={<BiBox />}
					title={
						<Typo texto="light" type="primary">
							Total unidades
						</Typo>
					}
				/>
				<Box
					data={dashboard?.totalOrders}
					subData={
						dashboard?.actualMonthOrders > 0
							? dashboard?.actualMonthOrders
							: null
					}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					graphData={timeOrderGraph}
					isLoading={isLoading}
					type="headerBox"
					prefix={<BiBox />}
					title={
						<Typo texto="light" type="primary">
							Total pedidos
						</Typo>
					}
				/>
			</HeaderContainer>
			<DoubleChartContainer>
				<Box
					type="timeChartMultipleProduct"
					options={laboratorySalesGraph}
					iconOption={<BiDollar size={20} />}
					option2={laboratoryUnitsGraph}
					iconOption2={<BiCoinStack size={20} />}
					selectProductGraph={selectLaboratoryGraph}
					productGraph={laboratoryGraphSelector}
					isLoading={isLoading}
					title={
						<Typo texto="light" type="primary">
							{laboratoryGraphSelector === "SALES"
								? "Ventas por laboratorio"
								: laboratoryGraphSelector === "UNITS"
								? "Unidades por laboratorio"
								: ""}
						</Typo>
					}
				/>
				<Box
					type="pieHeaderBoxSales"
					options={optionsPie}
					options2={optionsPie2}
					isLoading={isLoading}
					prefix={<MdSafetyDivider />}
					selectDistributorsInfo={selectDistributorsInfo}
					distributorsInfo={distributorsInfoSelector}
					iconOption={<BiDollar size={20} />}
					iconOption2={<BiBox size={20} />}
					title={
						<Typo texto="light" type="primary">
							{distributorsInfoSelector === "UNITS"
								? "Droguerías: pedidos"
								: distributorsInfoSelector === "SALES"
								? "Droguerías: ventas"
								: ""}
						</Typo>
					}
				/>
			</DoubleChartContainer>
		</Dashboard1Container>
	);
}
